import { categoryFacetType } from '../types';
import { convertLabelToId } from './convertLabelToId';

export const organizeFacets = (
  rawFacets: categoryFacetType[],
): categoryFacetType => {
  const foundFacetCategory = rawFacets.find(
    (facet: categoryFacetType) => facet.field === 'categories',
  );

  if (foundFacetCategory) {
    foundFacetCategory.values = foundFacetCategory.values.map((value) => {
      return {
        ...value,
        category_id: convertLabelToId(value.label),
      };
    });
  }

  return foundFacetCategory ? foundFacetCategory : rawFacets[0];
};
